import React, { memo } from 'react';
import MenuHeader from '../../../menu-category/MenuApp';
import ContactAdmin from '../../../../components/contact-admin/ContactAdmin';

const OptionsAndMenu = (props) => {
  return (
    <div className="align-content-stretch align-items-stretch justify-content-start f-row f-00auto" {...props}>
      <div className={'f-row f-grow-1'}>
        <div className="item">
          <MenuHeader />
        </div>
        <div className={'d-flex f-grow-1 mr-8p w-search-wrapper'}>
          <ContactAdmin />
        </div>
      </div>
    </div>
  );
};

export default memo(OptionsAndMenu);
